export function defaultGroupLabelProvider(groupName) {
    if (groupName === 'formUs') {
        return 'Form (US Specific)';
    }
    const label = groupName.replace(/([A-Z])/g, ' $1');
    return label.substring(0, 1).toUpperCase() + label.substring(1);
}
